<style>
.center {
  margin: 20px 0 0 20px;
}
</style>
<template>
  <ut-form :label-width="200">
    <ut-input placeholder="请描述您的监控项" v-show="false" v-model="id" readonly :style="{width:'500px'}"></ut-input>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 监控名称：
      </template>
      <ut-input placeholder="请描述您的监控项" v-model="name" :style="{width:'500px'}"></ut-input>
    </ut-form-item>
    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 目标监控URL：
      </template>
      <ut-input class="demo-input" v-model="url" :style="{width:'500px'}">
        <template slot="addonBefore" :style="{width:'100px'}">
          <ut-select v-model="requestType" class="demo-input-select" :style="{width:'100px'}">
            <ut-option
              v-for="item in reqTypeData"
              :value="item.value"
              :key="item.value"
              :label="item.label"
            ></ut-option>
          </ut-select>
        </template>
      </ut-input>
    </ut-form-item>
    <ut-form-item label="请求参数"  v-show="postInputShow" >
      <ut-input v-model="reqContent" :style="{width:'500px'}"></ut-input>
    </ut-form-item>
    <ut-form-item v-show="postInputShow">
      <template slot="label">
        <span style="color:red">*</span> content-type
      </template>
      <ut-select v-model="contentTypeValue" class="demo-input-select" :style="{width:'150px'}">
        <ut-option
          v-for="item in contentType"
          :value="item.value"
          :key="item.value"
          :label="item.label"
        ></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 测试URL探测：
      </template>
      <ut-button type="primary" @click="test" :disabled="isDisable">测试</ut-button>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 请选择应用
      </template>
      <ut-select v-model="selected1" filterable :style="{width:'500px'}" :filter-method='filter'>
        <ut-option v-for="item in appSearchOptions||appOptions" :value="item.appId" :key="item.appId" :label="item.appId"></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item label>
      <template slot="label">
        <span style="color:red">*</span>报警策略
      </template>
      <ut-select v-model="selected2" filterable :style="{width:'500px'}">
        <ut-option v-for="item in policyOptions" :value="item.id" :key="item.id" :label="item.name"></ut-option>
      </ut-select>
    </ut-form-item>

    <ut-form-item>
      <template slot="label">
        <span style="color:red">*</span> 是否生效：
      </template>
      <ut-radio-group v-model="isEffect">
        <ut-radio-button value="true">生效</ut-radio-button>
        <ut-radio-button value="false">失效</ut-radio-button>
      </ut-radio-group>
    </ut-form-item>

    <ut-form-item>
      <ut-button type="primary" @click="submit">立即更新</ut-button>
      <ut-button @click="goBack">取消</ut-button>
    </ut-form-item>
  </ut-form>
</template>

<script lang="babel">
export default {
  data() {
    return {
        name:'',
        url:'',
        isDisable:false,
        isEffect:'',
        selected1: '',
        selected2: '',
        appOptions: [],
        appSearchOptions: null,
        policyOptions:[],
        id : '',
        reqContent:"",
        requestType:"",
        reqTypeData:[
          {value:0,label:"GET"},
          {value:1,label:"POST"}
        ],
        contentTypeValue:0,
        contentType:[
          {value:0,label:"application/json"},
        ],
    }
  },computed:{
    postInputShow(){
      if(this.requestType == "1"){
        return true;
      }else{
        return false;
      }
    }
  },
  methods:{
    filter (val) {
      const data = []
      this.appOptions.map(item => {
          if (item.appId.toLowerCase().indexOf(val) !== -1 || item.appName.toLowerCase().indexOf(val) !== -1) {
            data.push(item)
          }
      })
      if (data.length) {
        this.appSearchOptions = data;
      } else {
        this.appSearchOptions = [];
      }
    },
    submit(){
      var name = this.name;
      var url = this.url;
      var isEffect = this.isEffect;
      var appId = this.selected1;
      var alarmPolicyId = this.selected2;

      if(name == ""){
        this.$message.error('监控名称不能为空');
        return false;
      }
      if(url == ""){
        this.$message.error('url 不能为空');
        return false;
      }

      if(isEffect == ""){
         this.$message.error('请选择是否生效');
        return false;
      }
      if(this.selected1 == ""){
        this.$message.error('应用不能为空');
        return false;
      }
      if(this.selected2 == ""){
        this.$message.error('报警策略不能为空');
        return false;
      }
      var sendData = {};
      sendData.name = name;
      sendData.appId = appId;
      sendData.alarmPolicyId = alarmPolicyId;
      sendData.url = url;
      sendData.isEffect= isEffect;
      sendData.id = this.id
      sendData.requestType = this.requestType
      sendData.postContent = this.reqContent
      sendData.bizType = 0;
      
      this.$http({
        method: "post",
        url: "urls/update.htm",
        data: JSON.stringify(sendData)
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response); //请求成功返回的数据
          if(response.data.code == 0){
            this.$message.success('修改成功');
            this.$router.push({ path: "/urls" });
          }else{
            this.$message.error(response.data.message);
            return false;
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    goBack(){
      this.$router.push({ path: "/urls" });
    },
    test(){
      var name = this.name;
      var url = this.url;
      var isEffect = this.isEffect;
      var appId = this.selected1;
      var alarmPolicyId = this.selected2;


      if(url == ""){
        this.$message.error('url 不能为空');
        return false;
      }


      var sendData = {};

      sendData.url = url;
      sendData.urlPath = url;
      sendData.content = this.reqContent
      sendData.requestType = this.requestType

      this.isDisable = true;
      this.$http({
      method: "post",
      url: "urls/ping.htm",
      data: sendData
      })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response); //请求成功返回的数据
        if(response.data.code == 200){
          this.$message.info(response.data.message);
        }else{
            this.$message.error('连接不通');
        }
        this.isDisable = false;
      })
      .catch(error => {
        this.isDisable = false;
        console.log(error); //请求失败返回的数据
        this.$message.error('连接不通');
      });
    }
  },
  created() {
    // 应用加载
    this.$http({
      method: "post",
      url: "apps/list.htm",
      data: "{}"
    })
      .then(response => {
        //这里使用了ES6的语法
        console.log(response.data.length); //请求成功返回的数据
        this.appOptions = response.data;
      })
      .catch(error => {
        console.log(error); //请求失败返回的数据
      });
    // 报警策略加载
    this.$http({
        method: "post",
        url: "policys/list.htm",
        data: "{}"
      })
        .then(response => {
          //这里使用了ES6的语法
          this.policyOptions = response.data;
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    this.$http({
        method: "post",
        url: "urls/"+this.$route.query.id+"/get.htm",
        data: "{}"
      })
        .then(response => {
          //这里使用了ES6的语法
          console.log(response.data)
          this.selected2 = response.data.alarmPolicyId;
          this.selected1 = response.data.appId;
          this.isEffect = String(response.data.isEffect)
          this.name = response.data.name;
          this.url = response.data.url;
          this.id = response.data.id;

          this.requestType = response.data.requestType;
          this.reqContent = response.data.postContent;
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
  }
}
</script>
<style lang="less">
.demo-input {
  .utear-input + .utear-input {
    margin-top: 15px;
  }
  .demo-input-select {
    display: block;
    margin: -10px;
    .utear-input {
      width: 100px;
      input {
        border: 0;
        background: transparent;
        color: #99a9bf;
      }
    }
  }
}
</style>